<template>
    <div>
        <Card>
            <Card>

                <p slot="title">
                    <Button to="/content/article/list" type="text" size="small" icon="md-arrow-back"></Button>
                    {{t.routerName}}
                </p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.article.title">
                                <Input v-model="formItem.title"
                                       :placeholder="msgUtil.placeholderRequired(t.article.title)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.article.charge">
                                <Select v-model="formItem.charge" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.charge)">>
                                    <Option value="0">{{t.article.charge0}}</Option>
                                    <Option value="1">{{t.article.charge1}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.article.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.status)">>
                                    <Option value="0">{{t.article.statusOption0}}</Option>
                                    <Option value="1">{{t.article.statusOption1}}</Option>
                                    <Option value="2">{{t.article.statusOption2}}</Option>
                                    <Option value="9">{{t.article.statusOption9}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.article.disabled">
                                <Select v-model="formItem.disabled" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.disabled)">>
                                    <Option value="0">{{t.article.yes}}</Option>
                                    <Option value="1">{{t.article.no}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8" class="">
                            <Form-item :label="t.article.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.article.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8" class="">
                            <Form-item :label="t.article.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.article.createEndTime)"
                                            :options="createEndTimeOption" @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="16">
                            <Form-item :label="t.article.body">
                                <Input v-model="formItem.body"
                                       :placeholder="msgUtil.placeholderRequired(t.article.body)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Button type="primary" icon="ios-search" style="float:right" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>

</template>

<script>
    import {Message, Tag} from 'iview';
    import {getArticleHistoryList} from '@/api/article';
    import sortButtonGroup from '@/components/sort-button-group.vue';

    export default {
        name: 'content_article_history_list',
        components: {
            sortButtonGroup,
        },
        data() {
            const t = this.$_t();
            const msgUtil = this.$msgUtil;
            const renderStatus = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.status === '0') {
                    color = 'success';
                    text = t.article.statusOption0;
                } else if (row.status === '1') {
                    color = 'error';
                    text = t.article.statusOption1;
                } else if (row.status === '2') {
                    color = 'success';
                    text = t.article.statusOption2;
                } else if (row.status === '9') {
                    color = 'success';
                    text = t.article.statusOption9;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderCharge = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.charge === '0') {
                    color = 'error';
                    text = t.article.charge1;
                } else if (row.charge === '1') {
                    color = 'success';
                    text = t.article.charge0;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderDisabled = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.disabled === '0') {
                    color = 'error';
                    text = t.article.yes;
                } else if (row.disabled === '1') {
                    color = 'success';
                    text = t.article.no;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderAction = (h, params) => {
                const row = params.row;
                return h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './detail/' + row.id,
                        },
                    },
                    msgUtil.message.action.show
                );
            };
            return {
                self: this,
                t: t,
                msgUtil: msgUtil,
                data: [],
                // 排序btn
                sortButton: [
                    {key: 'author', value: t.article.author, order: 0},
                    {key: 'disabled', value: t.article.disabled, order: 0},
                    {key: 'status', value: t.article.status, order: 0},
                    {key: 'releaseTime', value: t.article.releaseTime, order: 0},
                ],
                // 入力条件
                formItem: {
                    title: '',
                    author: '',
                    charge: '0',
                    hits: '',
                    status: '',
                    disabled: '',
                    releaseTime: '',
                    createStartTime: '',
                    createEndTime: '',
                    oa: '',
                    od: '',
                    size: 10,
                    current: 1,
                },
                checkAllGroup: [],
                // table定义列
                columns: [
                    {title: '', type: 'selection', align: 'center', width: 44},
                    {title: t.table.id, key: 'id', align: 'center', width: 164},
                    {title: t.table.title, key: 'title', width: 220, tooltip: true},
                    {title: t.table.author, key: 'author', width: 164, tooltip: true},
                    {title: t.table.hits, key: 'hits', align: 'center', width: 100},
                    {title: t.table.charge, key: 'charge', align: 'center', width: 100, render: renderCharge},
                    {title: t.table.status, key: 'status', align: 'center', width: 120, render: renderStatus},
                    {title: t.table.createBy, key: 'createBy', width: 150, tooltip: true},
                    {title: t.table.releaseTime, key: 'releaseTime', width: 150},
                    {title: t.table.disabled, key: 'disabled', align: 'center', width: 100, render: renderDisabled},
                    { title: ' ', align: 'center' },
                    {
                        title: msgUtil.message.action.name,
                        key: 'operation',
                        align: 'center',
                        width: 130,
                        fixed: 'right',
                        render: renderAction,
                    },
                ],
                createStartTimeOption: {},
                createEndTimeOption: {},
                selectIds: [],
                total: 0,
                loading: false,
            };
        },
        methods: {
            //排序
            async orderClick(btn) {
                this.formItem.oa = '';
                this.formItem.od = '';
                if (btn.order === 1) {
                    this.formItem.oa = btn.key;
                } else if (btn.order === 2) {
                    this.formItem.od = btn.key;
                }
                await this.search(true);
            },
            // 检索数据
            async search(flg) {
                if (flg) {
                    this.formItem.current = 1;
                    this.$refs.page.currentPage = 1;
                }
                this.loading = true;
                await this.wrapperCreateTime();
                let articleDto = {};
                articleDto.title = this.formItem.title;
                articleDto.author = this.formItem.author;
                articleDto.body = this.formItem.body;
                articleDto.status = this.formItem.status;
                articleDto.disabled = this.formItem.disabled;
                articleDto.charge = this.formItem.charge;
                articleDto.status = this.formItem.status;
                articleDto.releaseTime = this.formItem.releaseTime;
                articleDto.oa = this.formItem.oa;
                articleDto.od = this.formItem.od;
                if (this.formItem.oa === '' && this.formItem.od === '') {
                    articleDto.od = 'releaseTime';
                }
                articleDto.current = this.formItem.current;
                articleDto.size = this.formItem.size;
                const result = await getArticleHistoryList(articleDto);
                if (result) {
                    this.data = result.page.records;
                    this.total = result.page.total;
                }
                this.loading = false;
            },
            //创建时间作成
            async wrapperCreateTime() {
                this.formItem.releaseTime = '';
                if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                    this.formItem.releaseTime = this.formItem.createStartTime + ',';
                }
                if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                    if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                        this.formItem.releaseTime = ',';
                    }
                    this.formItem.releaseTime += this.formItem.createEndTime;
                }
            },
            // 页号改变
            async pageChange() {
                this.formItem.current = this.$refs.page.currentPage;
                await this.search(false);
            },
            // 每页显示数据
            async pageSizeChange() {
                this.formItem.size = this.$refs.page.currentPageSize;
                await this.search(false);
            },

            // 行选择
            rowSelect(selection) {
                this.selectIds = selection.map(p => {
                    return {id: p.id};
                });
            },
            /**
             * 开始时间发生变化时触发,设置结束时间不可选择的日期
             * 结束时间应大于等于开始时间,且小于等于当前时间
             * @param {string} startTime 格式化后的日期
             * @param {string} type 当前的日期类型
             */
            onStartTimeChange(startTime, type) {
                this.formItem.createStartTime = startTime;
                this.createEndTimeOption = {
                    disabledDate(endTime) {
                        return endTime < new Date(startTime) || endTime > Date.now();
                    },
                };
            },
            /**
             * 结束时间发生变化时触发,设置开始时间不可选择的日期
             * 开始时间小于等于结束时间,且小于等于当前时间
             * @param {string} date 格式化后的日期
             * @param {string} type 当前的日期类型
             */
            onEndTimeChange(endTime, type) {
                this.formItem.createEndTime = endTime;
                this.createStartTimeOption = {
                    disabledDate(startTime) {
                        return startTime > new Date(endTime) || startTime > Date.now();
                    },
                };
            },
        },
        async mounted() {
            await this.search(true);
        },
    };
</script>
<style>
</style>
